import { createApiQuery } from "~/shared/api/react-query-utils"

export const notificationsQuery = createApiQuery(
	"noty/integration/getUserNotificationList",
)
export const newNotificationsQuery = createApiQuery(
	"noty/integration/getNewUserNotificationList",
)